import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { importProcedure } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function importProceduresToAccount({
  accountId,
  checkedProcedures,
  urlPayload,
}: TVariables): Promise<TResult> {
  const response = await fetch(importProcedure(accountId, urlPayload), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(checkedProcedures),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: {
    AccountId: number;
    AccountName: string;
    ProcedureId: number;
    ProcedureName: string;
    IsGlobal: boolean;
  };
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  checkedProcedures: any;
  urlPayload: string;
};

type TSnapshot = unknown;

function useImportProcedures(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const formData = await importProceduresToAccount(params);
    if (formData.Data) {
      queryClient.invalidateQueries(['get_procedure_builder_procedures'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_global_procedures'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_archived_procedures'], {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(['get_procedure'], {
        refetchInactive: true,
      });
    } else if (formData.Errors) throw formData;
    return formData;
  });
}

export { useImportProcedures };
